import {
  BLACK,
  GRAY_0,
  GRAY_3,
  TODAY_BLUE,
  TODAY_INDIGO,
  TODAY_ORANGE,
} from "../colors"

type ErrorFallbackProps = {
  // Sentry.ErrorBoundary가 fallback render에 넘겨주는 이벤트 ID (지원 문의 시 참조용)
  eventId?: string | null
}

const FONT_STACK =
  '"Pretendard", "Pretendard Variable", -apple-system, BlinkMacSystemFont, "Apple SD Gothic Neo", sans-serif'

// 렌더 크래시 시 노출되는 최소 의존성 fallback. 깨진 트리·디자인 시스템에
// 의존하지 않도록 inline style + 순수 HTML/SVG로만 구성하고, 브랜드 컬러 토큰만
// 참조한다. (Today = 물류 브랜드 → 택배 박스 모티프)
export function ErrorFallback({ eventId }: ErrorFallbackProps) {
  return (
    <div
      role="alert"
      style={{
        display: "flex",
        minHeight: "100dvh",
        alignItems: "center",
        justifyContent: "center",
        padding: 24,
        boxSizing: "border-box",
        fontFamily: FONT_STACK,
        color: BLACK,
      }}
    >
      <div
        style={{
          width: "100%",
          maxWidth: 400,
          padding: "44px 32px",
          textAlign: "center",
          background: "#ffffff",
          border: `1px solid ${GRAY_0}`,
          borderRadius: 24,
          boxShadow: "0 12px 40px rgba(8, 18, 54, 0.08)",
        }}
      >
        <div
          style={{
            width: 72,
            height: 72,
            margin: "0 auto 24px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            borderRadius: 22,
            background: "#FFF1E9",
          }}
        >
          <svg
            width="34"
            height="34"
            viewBox="0 0 24 24"
            fill="none"
            stroke={TODAY_ORANGE}
            strokeWidth="1.7"
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden="true"
          >
            <path d="m7.5 4.27 9 5.15" />
            <path d="M21 8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16Z" />
            <path d="m3.3 7 8.7 5 8.7-5" />
            <path d="M12 22V12" />
          </svg>
        </div>

        <p
          style={{
            fontSize: 19,
            fontWeight: 700,
            letterSpacing: "-0.2px",
            color: TODAY_INDIGO,
            margin: "0 0 10px",
          }}
        >
          일시적인 오류가 발생했어요
        </p>
        <p
          style={{
            fontSize: 14,
            lineHeight: 1.7,
            color: GRAY_3,
            margin: "0 0 28px",
          }}
        >
          페이지를 불러오는 중 문제가 생겼어요.
          <br />
          잠시 후 다시 시도해 주세요.
        </p>

        <button
          type="button"
          onClick={() => window.location.reload()}
          style={{
            width: "100%",
            padding: "13px 24px",
            fontSize: 15,
            fontWeight: 600,
            fontFamily: FONT_STACK,
            color: "#ffffff",
            background: TODAY_BLUE,
            border: "none",
            borderRadius: 14,
            cursor: "pointer",
            boxShadow: "0 6px 16px rgba(0, 117, 255, 0.28)",
          }}
        >
          새로고침
        </button>

        {eventId ? (
          <p style={{ margin: "22px 0 0" }}>
            <span
              style={{
                display: "inline-block",
                padding: "5px 12px",
                fontSize: 11,
                fontFamily:
                  "ui-monospace, SFMono-Regular, Menlo, Consolas, monospace",
                color: GRAY_3,
                background: GRAY_0,
                borderRadius: 8,
              }}
            >
              오류 코드 · {eventId}
            </span>
          </p>
        ) : null}
      </div>
    </div>
  )
}

export default ErrorFallback
